/**
 * This loads some of the javascriptJavaScript
 * Some vendor packages are also located in public dir /js and are not
 * transpiled.
 */

/* Libs loaded for everyone */
import $ from 'jquery'
window.$ = $

import 'jquery.cycle2'

/**
 * Custom js
 */
require('./shared/core')
require('./shared/utils')
// require('./shared/mod-broccoli-cookie-law');

/* Custom libs */
require('./libs/view-more')
require('./libs/faqs')
require('./libs/broccoli-cookie-law');
require('./libs/google-analytics');

/* Layouts */
require('./layouts/main')

/* Contents */
require('./contents/home');
require('./contents/product');
require('./contents/search-results');
require('./contents/lib-document-list');
require('./contents/lib-user-registration');

/* Partials */
require('./partials/mobile-menu')
require('./partials/main-header')
require('./partials/main-footer')
require('./partials/main-search-textbox')
require('./partials/main-header-submenu')
require('./partials/contact-floating')
require('./partials/contact-form-modal')
require('./partials/home-slider')
require('./partials/family-table')
require('./partials/add-to-any')
require('./partials/lib-support-ticket-form-modal')
